"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnviromentVariablesManager = void 0;
class EnviromentVariablesManager {
    getVariable(key) {
        return window[String(key)];
    }
}
exports.EnviromentVariablesManager = EnviromentVariablesManager;
//# sourceMappingURL=environmentVariablesManager.js.map